import React, { forwardRef } from 'react';

import { headWeight, CONTENT_TYPE } from '../../config';
import { FlexDiv } from 'commonStyles';
import Content from '../ContentSection/Content';
import { BulletStyle, ListHead, NumberBullet, ListingWrapper } from '../ContentSection/ContentStyle';

const Listing = ({ listing, styles = {}, forwardedRef }) => (
	<ul ref={forwardedRef}>
		{listing?.length > 0 && listing.map((list, index) =>{
			const { heading, content: listContent, styles: listStyles = {} } = list;
			const hasContent = listContent?.length > 0;
			return (
				<ListingWrapper key={heading} bottom_P={(index === listing.length - 1) ? 0 : (styles.listSpacing || '20')}>
					<FlexDiv as='li' bottom_M={!hasContent ? 0 : '10'} align='flex-start'>
						<NumberBullet
							as='span'
							f_weight='700'
							align='center'
							color={styles.outerCircleColor || '#FF664B'}
							$bg={styles.outerCircleColor || '#FFE3DE'}
							right_M='8' fsize='12' height='20px' $width='20px' bdrRad='50%'>
							{CONTENT_TYPE.NUMBER === styles.listStyle ? index + 1 :
							<BulletStyle color={styles.color} />}
						</NumberBullet>
						<ListHead color='#000' fsize='14px' f_weight={headWeight[listStyles.fontWeight]} dangerouslySetInnerHTML={{ __html: heading }} />
					</FlexDiv>
					{hasContent &&
						<FlexDiv left_M='25' justify='flex-start'>
							<Content content={listContent} />
						</FlexDiv>}
				</ListingWrapper>
			);
		})}
	</ul>
);

export default forwardRef((props, ref) => <Listing {...props} forwardedRef={ref} />);
